export const getPhoneDetails = (
  inputPhoneNumber: string,
): { phoneNumber: string; phoneCountryCode: string } => {
  const phoneSplit = inputPhoneNumber?.split(' ') ?? [];
  const isSeparateCountryCode = phoneSplit.length > 1;
  const phoneNumber = isSeparateCountryCode ? phoneSplit.splice(1).join('') : inputPhoneNumber;
  const phoneCountryCode = isSeparateCountryCode ? phoneSplit[0] : '';

  return {
    phoneNumber,
    phoneCountryCode,
  };
};
